import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { addToCart, removeFromCart } from '../Actions/cartActions';
import MessageBox from '../Components/MessageBox';
import { useToast } from '../Context/ToastContext';

export default function CartScreen(props) {
    const productId = props.match.params.id;
    const qty = props.location.search? Number(props.location.search.split('=')[1]):1;


    const cart = useSelector((state) => state.cart);
    const { cartItems } = cart;

    const dispatch = useDispatch()
    const { success, warning } = useToast();
    const [itemToRemove, setItemToRemove] = useState(null);

    useEffect(() => {
        if(productId){
            dispatch(addToCart(productId,qty));
        }
    }, [dispatch,productId,qty])

    const removeFromCartHandler =(id) =>{
        // Use toast-based confirmation instead of blocking confirm dialog
        const item = cartItems.find(item => item.product === id);
        if (item) {
            warning(`Remove "${item.product_title}" from your cart?`, 5000);
            setItemToRemove(id);
        }
    }

    const confirmRemoveItem = () => {
        if (itemToRemove) {
            dispatch(removeFromCart(itemToRemove));
            success('Item removed from cart!');
            setItemToRemove(null);
        }
    }

    const cancelRemoveItem = () => {
        setItemToRemove(null);
    }

    const checkOutHandler = () => {
        props.history.push('/signin?redirect=shipping')
    }
    return (
        <div className="cart-page row top">
            <div className="col-2">
                <h1>Shopping Cart</h1>
                {cartItems.length === 0 ? (
                    <MessageBox>
                        Cart is empty. <Link to="/">Go For Shopping...</Link>
                    </MessageBox>
                ) : (
                <ul className="cart-list">
                    {cartItems.map((item) => (
                        <li key={item.product} className={`cart-item-card ${itemToRemove === item.product ? 'confirming' : ''}`}>
                            <div className="row cart-item-row">
                                <div className="cart-item-image">
                                    <img
                                        src={item.product_image_1}
                                        alt={item.product_title}
                                        className="small"
                                    />
                                </div>
                                <div className="cart-item-info min-30">
                                    <Link to={`/product/${item.product}`} className="cart-item-title">{item.product_title}</Link>
                                    {item.brand && (<div className="cart-item-meta">Brand: {item.brand}</div>)}
                                    <div className="cart-item-price">
                                        {item.cutted_price && Number(item.cutted_price) > Number(item.product_price) && (
                                            <span className="mrp">₹ {item.cutted_price}/-</span>
                                        )}
                                        <span className="price-now">₹ {item.product_price}/-</span>
                                    </div>
                                </div>
                                <div className="cart-item-qty">
                                    <select 
                                        value={Math.max(item.qty, Number(item.min_quantity) || 1)}
                                        onChange={(e) =>
                                            dispatch(addToCart(item.product, Number(e.target.value)))
                                        }
                                    >
                                        {
                                            (() => {
                                                const minQ = Math.max(1, Number(item.min_quantity) || 1);
                                                const maxByStock = Math.max(1, Number(item.stock_quantity) || 1);
                                                const maxQ = Math.max(1, Number(item.max_quantity) || 1);
                                                const allowedMax = Math.max(minQ, Math.min(maxQ, maxByStock));
                                                const options = [];
                                                for (let q = minQ; q <= allowedMax; q++) {
                                                    options.push(<option key={q} value={q}>{q}</option>);
                                                }
                                                return options;
                                            })()
                                        }
                                    </select>
                                    <div className="cart-qty-hint">Min {Math.max(1, Number(item.min_quantity) || 1)} · Max {Math.max(1, Math.min(Number(item.max_quantity)||1, Number(item.stock_quantity)||1))}</div>
                                </div>
                                <div className="row cart-item-actions" style={{gap: '8px'}}>
                                    {itemToRemove === item.product ? (
                                        <>
                                            <button
                                                className="danger"
                                                type="button"
                                                onClick={confirmRemoveItem}
                                            >
                                                Yes, Remove
                                            </button>
                                            <button
                                                className="secondary"
                                                type="button"
                                                onClick={cancelRemoveItem}
                                            >
                                                Cancel
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button className="secondary"
                                                type="button"
                                                onClick={() => removeFromCartHandler(item.product)}
                                            >
                                                Remove from Cart
                                            </button>
                                            <button
                                                className="primary"
                                                type="button"
                                                onClick={() => {
                                                    try { localStorage.setItem('checkoutItem', JSON.stringify({ productId: item.product, qty: item.qty })); } catch (_) {}
                                                    props.history.push('/signin?redirect=shipping');
                                                }}
                                            >
                                                Buy Now
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
                )}
            </div>
            <div className="col-1 cart-summary-col">
                <div className="card card-body cart-summary">
                    <ul>
                        <li>
                            <h2>
                                Subtotal ( { cartItems.reduce(( a, c) => a + c.qty, 0)} items) : 
                                ₹ {cartItems.reduce((a, c) => a + c.product_price*c.qty,0)}/-
                            </h2>
                        </li>
                        {/* Removed global proceed button as per requirement */}
                    </ul>
                </div>
            </div>
        </div>
    );
}
